<template>
  <span
    class="relative inline-flex rounded-md shadow-sm page-email-builder-template__btn-save"
  >
    <UIButton
      :id="id"
      use="secondary"
      @click="$emit('click')"
      size="small"
      class="relative ml-4 bg-white text-curious-blue-500 hover:bg-curious-blue-20"
      :class="loading ? 'pointer-events-none' : ''"
      ><UISpinner
        v-if="loading"
        size="small"
        color="#38A0DB"
        class="absolute top-0"
        :style="{ left: 'calc(50% - 11px)' }"
      />
      <div :class="{ invisible: loading }">{{ $t(label) }}</div>
    </UIButton>
    <span
      class="flex absolute h-3 w-3 top-0 right-0 -mt-1 -mr-1"
      v-if="unsavedChanges"
    >
      <span
        class="animate-ping absolute inline-flex h-full w-full rounded-full bg-curious-blue-500 opacity-75"
      ></span>
      <span
        class="relative inline-flex rounded-full h-3 w-3 bg-curious-blue-500"
      ></span>
    </span>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { UIButton, UISpinner } from '@gohighlevel/ghl-canvas'

export default defineComponent({
  components: { UIButton, UISpinner },
  emits: ['click'],
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    unsavedChanges: { type: Boolean, required: false, default: false },
    label: {
      type: String,
      required: false,
      default: 'emailTemplate.saveTemplate',
    },
    id: { type: String, required: false },
  },
  setup(props, { emit }) {
    return {}
  },
})
</script>

<style scoped></style>
